import { render, staticRenderFns } from "./autocomplete-conversation.vue?vue&type=template&id=50fdf7ff&scoped=true&"
import script from "./autocomplete-conversation.vue?vue&type=script&lang=js&"
export * from "./autocomplete-conversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fdf7ff",
  null
  
)

export default component.exports